module.exports = __webpack_public_path__ + "img/farende-svend2.ec4178d9.jpg";